// Template1.tsx - Default template (classic thermal paper receipt)
import { ReactNode, FC } from "react";

import styles from "./template1.module.css";

export const Template1: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={styles.templateContainer}>{children}</div>;
};